import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRANSPORT_MILEAGE_GET } from 'api/query-keys.ts';
import type { TGetTransportPerformanceStatisticRes } from 'api/swagger';
import type { ITransportMileageFilter } from 'shared/stores/use-transport-mileage-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters?: ITransportMileageFilter;
  search?: string;
}

export const useGetTransportPerformance = (params: IParams) => {
  const { filters, search } = params;
  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<ITransportMileageFilter>(qs, filters);

  return useQuery<TGetTransportPerformanceStatisticRes>({
    queryKey: [TRANSPORT_MILEAGE_GET, { filters, search }],
    queryFn: async () => {
      const { data } = await http.get<TGetTransportPerformanceStatisticRes>(
        `/v1/statistics/transport-performance?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!filters,
  });
};
